export default __webpack_public_path__ + "static/media/top.623c1b2c.svg";